module.exports = __webpack_public_path__ + "static/metal-roofing-3d94125f04079a8c17b02ab38c2d178a.jpg";